/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { UpdateStaffMemberMutationRequest, UpdateStaffMemberMutationResponse, UpdateStaffMemberPathParams, UpdateStaffMember400, UpdateStaffMember401, UpdateStaffMember403, UpdateStaffMember404, UpdateStaffMember409, UpdateStaffMember500 } from "../../types/staffController/UpdateStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getUpdateStaffMemberUrl(organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"]) {
  const res = { method: 'PUT', url: `/api/organizations/${organizationId}/staff/${staffId}` as const }
  return res
}

/**
 * @summary Update staff member
 * {@link /api/organizations/:organizationId/staff/:staffId}
 */
export async function updateStaffMember(organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"], data: UpdateStaffMemberMutationRequest, config: Partial<RequestConfig<UpdateStaffMemberMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateStaffMemberMutationResponse, ResponseErrorConfig<UpdateStaffMember400 | UpdateStaffMember401 | UpdateStaffMember403 | UpdateStaffMember404 | UpdateStaffMember409 | UpdateStaffMember500>, UpdateStaffMemberMutationRequest>({ method : "PUT", url : getUpdateStaffMemberUrl(organizationId, staffId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}